import React from "react";
import HighchartsComponent from "@ui/Highcharts";
import useOptions from "./hooks/useOptions";
import type { SelectedQuantity } from "../../../../../../../useSelectedQuantities";
import type getSeries from "../../../../../../../Symptoms/Gap/getSeries";
import type { ActiveAnalysis } from "../../../../../../../../../api/useActiveAnalysesStream";
import type { Project } from "../../../../../../../../../api/useProjects";
import type { Source } from "../../../../../../../../../api/useSources";
import type { Event } from "../../../../../../../../../api/useEvents";

interface P {
  chartRef: React.RefObject<Highcharts.Chart>;
  analyses: ActiveAnalysis[];
  project: Project;
  source: Source;
  timeZone: string;
  selectedQuantities: SelectedQuantity[];
  series: ReturnType<typeof getSeries>;
  event: Event;
}

const Gap = ({
  chartRef,
  analyses,
  project,
  source,
  selectedQuantities,
  series,
  timeZone,
  event,
}: P) => {
  const options = useOptions({
    chartRef,
    selectedQuantities,
    series,
    analyses,
    project,
    source,
    timeZone,
    event,
  });

  return (
    <HighchartsComponent
      name="Symptoms gap"
      ref={chartRef}
      options={options}
      normalizeNavigatorSeries
      selectablePoints={false}
      timezone={timeZone}
    />
  );
};

export default React.memo(Gap);
